window.Products.Accessory.PrintedPatch = function() {};
window.Products.Accessory.PrintedPatch.inherits(window.Products.Accessory.Accessory);